import { GridContainer } from '@vp/swan'
import { Article } from '../../types/article.type'
import { ArticleContent } from '../article-content/ArticleContent'
import { BreadcrumbsComponent } from '../breadcrumbs/Breadcrumbs'
import { HelpCenterUrls } from '../../types/helpCenterUrls.type'
import './Article.scss'

interface ArticleProps {
  locale: string
  tenant: string
  article: Article
  handleBackBtnClick: () => void
  helpCenterUrls: HelpCenterUrls | null
  useStaging?: boolean
}

export const ArticleView = (props: ArticleProps) => {
  const { locale, tenant, article, helpCenterUrls, useStaging } = props

  return (
    <>
      <GridContainer>
        <BreadcrumbsComponent article={article} locale={locale} tenant={tenant} helpCenterUrls={helpCenterUrls} />
      </GridContainer>
      <ArticleContent article={article} tenant={tenant} helpCenterUrls={helpCenterUrls} locale={locale} useStaging={useStaging} />
      <GridContainer></GridContainer>
    </>
  )
}
